/**
 * Folder permission helpers.
 * If no access info is present (legacy mode), allow by default.
 */
import { SYSTEM_FOLDER_NAMES } from '@/modules/file/_helpers/systemFolders'

const hasAccessInfo = (folder) => {
  if (!folder || typeof folder !== 'object') return false
  if (!Object.prototype.hasOwnProperty.call(folder, 'access')) return false
  return folder.access != null
}

const isBookkeepingSystemFolder = (folder) => {
  if (!folder?.isSystemFolder) {
    return false
  }

  if (folder?.folderType === 'bookkeeping') {
    return true
  }

  return folder?.name === SYSTEM_FOLDER_NAMES.BOOKKEEPING
    || folder?.folderPath?.startsWith(`${SYSTEM_FOLDER_NAMES.BOOKKEEPING}/`)
}

export const canWriteFolder = (folder) => {
  if (!hasAccessInfo(folder)) return true
  return Boolean(folder?.access?.can_write || folder?.access?.owner)
}

export const canDeleteFolder = (folder) => {
  if (!hasAccessInfo(folder)) return true
  return Boolean(folder?.access?.can_delete || folder?.access?.owner)
}

export const canShareFolder = (folder) => {
  return Boolean(folder?.access?.owner) && !isBookkeepingSystemFolder(folder)
}

export const getFolderAccessLevel = (folder) => {
  if (!folder?.access) return null
  if (folder.access.owner) return 'owner'
  if (folder.access.can_write) return 'editor'
  if (folder.access.can_read) return 'viewer'
  return null
}

export const filterWritableFolderTree = (folder) => {
  if (!folder) return null

  const children = Array.isArray(folder.children) ? folder.children : []
  const filteredChildren = children
    .map((child) => filterWritableFolderTree(child))
    .filter(Boolean)

  const keep = canWriteFolder(folder) || filteredChildren.length > 0
  if (!keep) return null

  return {
    ...folder,
    children: filteredChildren,
  }
}
